export const flowPersonalDataZH = {
  flowPersonalData1: '我的主页',
  flowPersonalData2: '此信息是用于方便下次报名使用；如需修改已报名活动的报名资料，请前去[个人]-[我的活动]-[活动任务]-[报名]处修改。',
  flowPersonalData3: '修改头像',
  flowPersonalData4: '基本信息',
  flowPersonalData5: '昵称',
  flowPersonalData6: '请输入昵称',
  flowPersonalData7: '个人介绍',
  flowPersonalData8: '请输入个人介绍',
  flowPersonalData9: '标签',
  flowPersonalData10: '（让大家看到你的特别，最多可选5个）',
  flowPersonalData11: '中文姓名',
  flowPersonalData12: '请输入中文姓名',
  flowPersonalData13: '性别',
  flowPersonalData14: '男',
  flowPersonalData15: '女',
  flowPersonalData16: '出生日期',
  flowPersonalData17: '选择日期',
  flowPersonalData18: '在读学校',
  flowPersonalData19: '请选择在读学校',
  flowPersonalData20: '联系方式',
  flowPersonalData21: '电子邮件',
  flowPersonalData22: '请输入电子邮件',
  flowPersonalData23: '保存',
  flowPersonalData24: '请输入昵称',
  flowPersonalData25: '昵称不可超过30个字符',
  flowPersonalData26: '修改成功',
  flowPersonalData27: '添加',
  flowPersonalData28: '新增标签',
  flowPersonalData29: '已选',
  flowPersonalData30: '头像',
  flowPersonalData31: '更多资料',
  flowPersonalData32: '修改昵称',
  flowPersonalData33: '请输入新昵称',
  flowPersonalData34: '修改头像成功',
  flowPersonalData35: '修改头像失败',
  flowPersonalData36: '上传失败,请重试',
  flowPersonalData37: '昵称不能为空',
  flowPersonalData38: '修改昵称成功',
  flowPersonalData39: '修改昵称失败',
  flowPersonalData40: '修改标签成功',
  flowPersonalData41: '修改标签失败',
  flowPersonalData42: '简单用几句话介绍一下自己吧',
  flowPersonalData43: '修改失败'
}

export const flowPersonalDataEN = {
  flowPersonalData1: 'My home page',
  flowPersonalData2: 'This information is for the convenience of the next registration. If you need to modify the registration information of the activity, please go to [Personal] - [My activities] - [activity Tasks] - [Registration] to modify.',
  flowPersonalData3: 'Modify the profile photo',
  flowPersonalData4: 'Basic information',
  flowPersonalData5: 'Nickname',
  flowPersonalData6: 'Please enter a nickname',
  flowPersonalData7: 'Personal Introduction',
  flowPersonalData8: 'Please enter personal introduction',
  flowPersonalData9: 'Label',
  flowPersonalData10: '(Let people see you traits, up to 5)',
  flowPersonalData11: 'Chinese name',
  flowPersonalData12: 'Please enter your Chinese name',
  flowPersonalData13: 'Gender',
  flowPersonalData14: 'Male',
  flowPersonalData15: 'Female',
  flowPersonalData16: 'Date of birth',
  flowPersonalData17: 'Select date',
  flowPersonalData18: 'Current School',
  flowPersonalData19: 'Please select your school',
  flowPersonalData20: 'Contact information',
  flowPersonalData21: 'E-mail',
  flowPersonalData22: 'Please enter email',
  flowPersonalData23: 'Save',
  flowPersonalData24: 'Please enter a nickname',
  flowPersonalData25: 'Nicknames should not be longer than 30 characters',
  flowPersonalData26: 'Edited successfully',
  flowPersonalData27: 'Add',
  flowPersonalData28: 'New tags',
  flowPersonalData29: 'Selected',
  flowPersonalData30: 'profile photo',
  flowPersonalData31: 'More information',
  flowPersonalData32: 'Change the nickname',
  flowPersonalData33: 'Please enter a new nickname',
  flowPersonalData34: 'Modified profile photo successfully',
  flowPersonalData35: 'Failed to change profile photo',
  flowPersonalData36: 'Upload failed. please try again',
  flowPersonalData37: 'Nicknames cannot be empty',
  flowPersonalData38: 'Modified nickname successfully',
  flowPersonalData39: 'Failed to change nickname',
  flowPersonalData40: 'Successful tag modification',
  flowPersonalData41: 'Failed to change tag',
  flowPersonalData42: 'Introduce yourself in a few words',
  flowPersonalData43: 'Modification failed'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/personalData.js